<template>
  <div v-if="financials" class="block-financials">
    <info-card>
      <info-row v-for="item in metrics" :key="item.label" :label="item.label">
        <money v-if="item.money" :money="item.value"/>
        <template v-else>{{ item.value }}</template>
      </info-row>
    </info-card>

    <template v-if="financials.comment">
      <div class="dp-section-title">Комментарии</div>
      <rich-content :html="financials.comment"/>
    </template>
  </div>
</template>

<script>
import Money from "@/components/common/components/Money.vue";
import InfoCard from "@/components/common/components/InfoCard.vue";
import InfoRow from "@/components/common/components/InfoRow.vue";
import RichContent from "@/components/common/components/RichContent.vue";

export default {
  name: "DetailedProjectFinancials",
  components: {Money, InfoCard, InfoRow, RichContent},
  props: {
    financials: {
      type: Object,
      required: true
    }
  },
  computed: {
    metrics() {
      const f = this.financials;
      return [
        {label: "Валюта баланса", value: f.coreAssets, money: true},
        {label: "Выручка", value: f.revenue, money: true},
        {label: "Собственный капитал", value: f.equityIncluding, money: true},
        {label: "Чистая прибыль", value: f.netProfit, money: true},
        {label: "Объем кредитных обязательств", value: f.amountOfCreditObligations, money: true},
        {label: "Количество сотрудников", value: f.numberOfEmployeesAtTheMoment, money: false},
      ];
    }
  }
};
</script>

